import { styled } from '../../Styles/stitches.config'

export const StyledSearchResults = styled('div', {
    ul: {
        m: 0,
        p: 0,

        li: {
            borderBottom: '1px solid $neutral300',
            py: 16,
            cursor: 'pointer',
        },
    },
})
